<template>
  <v-dialog
    v-model="dialog"
    max-width="800px"
    scrollable
  >
  <template
    v-slot:activator="{ on }"
  >
    <v-container>
      <v-row
        no-gutters
      >
        <v-col
          cols="12"
        >
          <AttachmentsFilesList
            :title="title"
            :isLoading="getIsFetching"
            :attachmentsList="getListAttachments"
            :activatorText="activatorText"
            @download="handleDownload"
            @delete="handleDelete"
            :s3KeyDownloading="s3KeyDownloading"
          />
        </v-col>
        <v-col
          cols="12"
          class="text-right mt-1"
        >
          <v-btn class="btn-text-transform-capitalize" small color="wrld_red" dark v-on="on">{{ activatorText }}</v-btn>
        </v-col>
      </v-row>
    </v-container>
  </template>
    <v-card
      max-height="500px"
    >
      <v-card-title
        class="pb-0"
      >
        <v-container>
          <v-row
            no-gutters
          >
            <v-col
              cols="12"
              class="mb-4"
            >
              <span class="headline">{{ title }}</span>
            </v-col>
            <v-col
              cols="12"
              class="pb-0 mb-0"
            >
              <v-file-input
                  v-model="file"
                  counter
                  :label="$t('uploads.file_content')"
                  :placeholder="$t('uploads.no_file_selected')"
                  prepend-icon="fas fa-paperclip"
                  outlined
                  :show-size="1000"
                >
              </v-file-input>
            </v-col>
          </v-row>
        </v-container>
      </v-card-title>
      <v-divider></v-divider>
      <AttachmentsFilesList
        :isLoading="getIsFetching"
        :attachmentsList="getListAttachments"
        @download="handleDownload"
        @delete="handleDelete"
        :isDialog="true"
        :s3KeyDownloading="s3KeyDownloading"
      />
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
        color="wrld_black"
        text
        @click="handleCancel"
        >{{ $t('buttons.close') }}</v-btn>
        <v-btn
        color="wrld_red"
        class="white--text"
        :disabled="!isValid || getIsUploading"
        @click="handleUpload">
        <v-progress-circular
          v-if="getIsUploading"
          :width="4"
          :size="15"
          indeterminate
          color="wrld_black"
        ></v-progress-circular>
        <template
          v-else
        >
          {{ $t('uploads.upload') }}
        </template>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import AttachmentsFilesList from '@/components/wrld/generic/attachments/AttachmentsFilesList'
  export default {
    name: 'AttachmentsUpload',
    components: {
      AttachmentsFilesList
    },
    props: {
      title: {
        type: String
      },
      activatorText: {
        type: String
      },
      resource: {
        type: String,
        required: true
      },
      resourceID: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        dialog: false,
        file: null,
        hover: null,
        s3KeyDownloading: null
      }
    },
    methods: {
      ...mapActions({
        setListAttachments: 'attachments/setListAttachments',
        uploadRequest: 'attachments/uploadRequest',
        downloadRequest: 'attachments/downloadRequest',
        deleteAttachment: 'attachments/deleteAttachment'
      }),
      handleUpload () {
        this.uploadRequest({
          file: this.file,
          filename: this.file.name,
          resource: this.resource,
          resourceID: this.resourceID
        })
      },
      handleCancel () {
        this.file = null
        this.dialog = false
      },
      handleDownload (s3Key, filename) {
        this.downloadRequest({ s3Key, filename })
      },
      handleDelete (s3Key) {
        this.deleteAttachment({ s3Key })
      }
    },
    computed: {
      ...mapGetters({
        getListAttachments: 'attachments/getListAttachments',
        getIsFetching: 'attachments/getIsFetching',
        getIsUploading: 'attachments/getIsUploading',
        getIsDownloading: 'attachments/getIsDownloading'
      }),
      isValid () {
        return this.file != null
      }
    },
    watch: {
      dialog: {
        immediate: true,
        handler(val, oldVal) {
          if (oldVal != null) {
            if (!oldVal && val) {
              this.setListAttachments({
                resource: this.resource,
                resourceID: this.resourceID
              })
            }
          }
        }
      },
      getIsUploading: {
        immediate: true,
        handler(val, oldVal) {
          if (oldVal != null) {
            if (oldVal && !val) {
              this.file = null
            }
          }
        }
      },
      getIsDownloading: {
        immediate: true,
        handler(val, oldVal) {
          this.s3KeyDownloading = val
        }
      }
    },
  }
</script>

<style lang="scss" scoped>
.attachment--card {
  border-radius: 5px;
  border-color: var(--v-wrld_grey-base) !important;
}
.overlay-loader-visible {
    position: absolute;
    width: 150px;
    height: 100%;
    padding-top: 20%;
    z-index: 10;
    visibility: visible;
    background: rgb(255, 255, 255, 0.9)
}
.overlay-loader-hidden {
    position: absolute;
    width: 150px;
    height: 100%;
    padding-top: 20%;
    z-index: 10;
    visibility: hidden;
    background: rgb(255, 255, 255, 0.9)
}
</style>
